import React from "react";
import "./AdminFormInput.css";

/**
 * Reusable form input component for Admin modals
 * Provides consistent styling with labels and error handling
 */
const AdminFormInput = ({
  label,
  name,
  value,
  onChange,
  type = "text",
  placeholder = "Enter here",
  error,
  required = false,
  disabled = false,
  className = "",
  ...props
}) => {
  return (
    <div className={`admin-form-group ${className}`}>
      {label && (
        <label htmlFor={name} className="admin-form-label">
          {label}
          {required && <span className="text-danger ms-1">*</span>}
        </label>
      )}
      <input
        id={name}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        className={`admin-form-input ${error ? 'has-error' : ''}`}
        {...props}
      />
      {error && <p className="admin-form-error">{error}</p>}
    </div>
  );
};

export default AdminFormInput;
